import { useGetStageNotes } from '../../api/stage'
import { notesPanelOpenState } from '../../atoms/layout'
import PanelContainer from '../common/PanelContainer'
import NoteBox from './NoteBox'
import SendNoteBar from './SendNoteBar'

interface Props {
  className?: string
  stageId: string
}

export default function NotesPanel({ stageId, className }: Props) {
  const { data: notes } = useGetStageNotes(stageId)

  return (
    <PanelContainer
      heightState={notesPanelOpenState}
      title="یادداشت‌ها"
      className={className}
      fadeButtom={false}
      id="notes-panel"
    >
      <div className="flex flex-col h-full">
        <div className="flex-grow space-y-2 overflow-auto">
          {notes?.length === 0 && (
            <div className="text-center text-zinc-600 text-sm"> یادداشتی وجود ندارد.</div>
          )}
          {notes?.map((note) => (
            <NoteBox
              content={note.content}
              createdAt={note.createdAt}
              creator={note.creator}
              key={note.createdAt}
            />
          ))}
        </div>
        <div className="bg-slate-200 sticky bottom-0 pt-2">
          <SendNoteBar stageId={stageId} />
        </div>
      </div>
    </PanelContainer>
  )
}
